import { useQuery } from '@tanstack/react-query';
import { UserRepository } from '@/repositories/UserRepository';
import { queryKeys } from '@/lib/queryKeys';

/**
 * Prénom, nom et rôle d'un profil (en-tête de l'application).
 * `enabled` permet de couper la requête quand il n'y a pas de ligne `profiles`
 * (visite par lien public).
 */
export function useProfileIdentity(userId: string | undefined, enabled: boolean = true) {
  return useQuery({
    queryKey: queryKeys.users.headerIdentity(userId),
    queryFn: async () => {
      if (!userId) return null;
      return UserRepository.getIdentity(userId);
    },
    enabled: !!userId && enabled,
  });
}
